export default "__VITE_ASSET__DkLJok6___"